import { createContext } from 'react';

export interface AutopilotConfigContextValue {
  configurationId: string | undefined;
  version: number | undefined;
}

export const AutopilotConfigContext = createContext<
  AutopilotConfigContextValue | undefined
>(undefined);
